module.exports = __webpack_public_path__ + "static/media/tree.c9536556.png";